import axios from 'axios'
const server = process.env.VUE_APP_API_URL || ''
const api = `${server}/api/admin/trello`

const getBoards = () => {
  return axios.get(api + '/boards')
}
const getBoard = (id) => {
  return axios.get(api + '/board/' + id)
}
const getLists = () => {
  return axios.get(api + '/lists/6780da026ed5ab21c1fa7512')
}
const getBoardLists = (boardId) => {
  return axios.get(api + '/lists/' + boardId)
}
const getList = (listId) => {
  return axios.get(api + '/list/' + listId)
}
const createProductionJobcards = (parms) => {
  return axios.post(api + '/customerordercard/', {...parms})
}
const createArtworkCard = (artworkData) => {
  return axios.post(api + '/artworkcard/', artworkData)
}

export default {
  getBoards,
  getBoard,
  getBoardLists,
  getLists,
  getList,
  createProductionJobcards,
  createArtworkCard
}
